import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import PlusIcon from "app/components/Icons/PlusIcon";
import IconText from "app/components/IconText";
import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { BOARD_TEMP_OPTIONS } from "app/data";
import { selectIsBoardCreate, selectUserDetailsData } from "app/redux/selector";
import { actions } from "app/redux/slice";
import { actions as actionsBoardSetting } from "./Settings/redux/slice";
import { BoardTemplateEnum } from "app/types";
import { useQueryState } from "nuqs";
import { useDispatch, useSelector } from "react-redux";

export default function AddBoard() {
  const params = useParams();
  const { project, team } = params;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const first2Options = BOARD_TEMP_OPTIONS.slice(0, 2);
  const remainingOptions = BOARD_TEMP_OPTIONS.slice(2);
  const [, setSettings] = useQueryState("settings");
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsBoardCreate);
  const userDetails = useSelector(selectUserDetailsData);

  const handleCreate = (type: BoardTemplateEnum) => {
    dispatch(
      actions.doCreateFixTempBoard({
        data: {
          projectId: project as string,
          teamId: team as string,
          templateType: type,
        },
        callback(id: string, viewType: BoardTemplateEnum) {
          dispatch(
            actions.updateNewBoardOrderState({
              selectedId: params.id as string,
              clickedId: id,
            })
          );
          navigate(`/app/${project}/${team}/boards/${id}/${viewType}/board`);
          dispatch(actions.doUpdateBoardOrder());
          dispatch(actionsBoardSetting.getBoard({ id: id }));
        },
        
      })
    );
    if (
      type === BoardTemplateEnum.KANBAN ||
      type === BoardTemplateEnum.LIST
    ) {
      dispatch(actionsBoardSetting.setClearDraftFrom());
      dispatch(actionsBoardSetting.setBoardLoading(true));
      setSettings(type?.toLowerCase());
    }
  };

  const renderOptions = (option) => {
    return (
      <DropdownMenuItem
        key={option.type}
        className="flex flex-row gap-[6px] p-[8px] focus:outline-none hover:bg-[#F4F5F7] rounded-[4px] cursor-pointer"
        onClick={() => {
          handleCreate(option.type as BoardTemplateEnum);
        }}
        disabled={isLoading}
      >
        <img
          className="size-[40px] min-w-[40px]"
          src={option.img}
          alt={option.title}
        />
        <div className="flex flex-col">
          <p className="text-black text-sm leading-[21px] font-medium">
            {option.title}
          </p>
          <p className="text-secondary text-xs leading-[18px] font-normal">
            {option.caption}
          </p>
        </div>
      </DropdownMenuItem>
    );
  };

  return (
    <DropdownMenu
      // open={open}
      // onOpenChange={() => {
      //   setOpen(!open);
      //   setSettings(null);
      // }}
    >
      <DropdownMenuTrigger asChild>
        <Link
          to="#"
          className={`hover:bg-gray-100 py-2 px-[10px] rounded-[4px] focus:outline-none ${
            open ? "border border-secondary" : ""
          }`}
        >
          <IconText
            className="gap-[6px]"
            text="View"
            textClassName="text-secondary text-sm leading-[21px] font-normal"
            icon={<PlusIcon size={20} />}
          />
        </Link>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="z-[20]  p-4 py-[26px] !w-[594px] bg-danger gap-[10px] z-10 !bg-white rounded-[4px] shadow-[2px_2px_6px_0px_rgba(237,239,242,0.70)] border border-[#E9ECF2]" // move to the right by 50%
        sideOffset={4}
      >
        <div className="grid grid-cols-2 gap-y-[10px]">
          {first2Options.map((option) => {
            return renderOptions(option);
          })}
        </div>

        <div className="bg-gray-100 h-[1px] w-full my-[10px]" />

        <p className="text-secondary text-xs leading-[18px] font-medium">
          Templates
        </p>
        <div className="grid grid-cols-2 gap-y-[10px]">
          {remainingOptions.map((option) => {
            return renderOptions(option);
          })}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
